import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { Routing } from '../../../../util/routes.util';
import { Tab, Tabs } from '../../../components/Tabs';
import StockLocationMapPane from './Map/StockLocationMapPane';
import StockLocationOverviewPane from './Management/StockLocationOverviewPane';

export default function StockLocationSettingsScreen() {
  return (
    <>
      <div className='content-x content-y-screen flex h-full flex-grow flex-col'>
        <Tabs>
          <Tab text={t(TranslationKey.overview).singular.upper} path={Routing.settings.stockLocations.overview()} />
          <Tab text={t(TranslationKey.map).singular.upper} path={Routing.settings.stockLocations.map()} />
        </Tabs>

        <div className='flex-grow overflow-hidden'>
          <Routes>
            <Route path='/overview' element={<StockLocationOverviewPane />} />
            <Route path='/map' element={<StockLocationMapPane />} />
          </Routes>
        </div>
      </div>
    </>
  );
}
